<template>
  <div data-qa="billerselection-div-vz2h7g">
    <v-layout  wrap class="ml-2 billPayments--gradientBGposition" data-qa="billerselection-layout-xcbujh">
          <v-flex
            xs12
            sm12
            md12
            lg12
            xl12
            :style="{ background: dashboardGradient, height: '180px'}"
           data-qa="billerselection-flex-mp6vwc">
            <v-container class="billPayments--title-padding" data-qa="billerselection-container-vssyyn">
                <v-flex xs12 sm12 md12 lg12 xl12 data-qa="billerselection-flex-gmwo3d">
                <v-row no-gutters data-qa="billerselection-row-jq01mx">
                  <v-layout row wrap class="pb-2 pl-12" data-qa="billerselection-layout-gpt1ti">
                <!-- <v-flex xs2 sm2 md2 lg1 xl1 class="pt-6 pl-12" data-qa="billerselection-flex-qtfr68"> -->
                  <!-- <v-row justify="start" class="pl-2" data-qa="billerselection-row-v18varj"> -->
                    <div class="pt-3" data-qa="billerselection-div-vlgfms">
                    <v-avatar :tile="false" size="35" color="white" data-qa="billerselection-avatar-g1pm7">
                      <v-icon :color="primaryColor" data-qa="billerselection-icon-desui5a">mdi-receipt</v-icon>
                    </v-avatar>
                    </div>
                  <!-- </v-row> -->
                <!-- </v-flex> -->
                <v-flex xs9 sm9 md9 lg9 xl9 class="pt-4 pl-2" data-qa="billerselection-flex-a8ls4">
                  <v-row no-gutters data-qa="billerselection-row-nkucj">
                    <font class="text-h5 font-weight-light white--text">
                      {{ $t("billPayments.title")}}</font
                    >
                  </v-row>
                </v-flex>
              </v-layout>
                </v-row>
              </v-flex>
            </v-container>
      </v-flex>
    </v-layout>
    <v-flex
          xs12
          sm12
          md12
          lg12
          xl12
          class="billPayments--content-padding billPayments--overlayCardFlex"
         data-qa="billerselection-flex-ncpdk7">
          <v-layout  row wrap class="billPayments--content-padding" data-qa="billerselection-layout-3hsoa">
            <v-flex
          sm12
          xs12
          md12
          lg12
          xl12
          class="hidden-md-and-up pb-2"
         data-qa="billerselection-flex-ybid3n">
          <bill-payments-history-btn
            :text="$t('billPayments.billPaymentHistory')"
            @click="navigateToHistory"
          />
        </v-flex>
            <v-flex xs12 sm11 md8 lg9 xl9 class="pt-0" data-qa="billerselection-flex-wdsls">
              <v-card data-qa="billerselection-card-9i3obb">
                <v-flex xs9 sm9 md9 lg9 xl9 class="pt-6 pl-5" data-qa="billerselection-flex-u1k1e">
                      <v-row no-gutters data-qa="billerselection-row-5qysu">
                        <font class="text-h6 font-weight-light billPayments--font-style">
                          {{ $t("billPayments.newBillPaymentLabel") }}</font
                        >
                      </v-row>
                </v-flex>
    <v-form ref="form" data-qa="billerselection-form-9ai368">
    <v-card-text class="grid-list-lg pr-7 pl-5 pb-0" data-qa="billerselection-card-text-ch7whg">
      <v-row data-qa="billerselection-row-427ohl">
        <v-flex xs12 sm7 md7 lg7 xl7 data-qa="billerselection-flex-1dfppm">
          <v-autocomplete
            data-qa="serviceProvided"
            v-model="biller.serviceProvided"
            @change="selectServiceProvided(biller.serviceProvided);confirmSelection()"
            :items="serviceProviders"
            :filter="customFilter"
            :color="primaryColor"
            append-icon="mdi-chevron-down"
            filled
            background-color="#f0eff7"
            item-text="codeDescription"
            item-value="codeReference"
            label="Biller Category"
            class="pt-4 pl-2"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 sm7 md7 lg7 xl7 data-qa="billerselection-flex-1wia9">
          <v-autocomplete
            data-qa="billerCategory"
            v-model="biller.category"
            @change="selectCategory(biller.category);confirmSelection()"
            :items="serviceFilterBiller"
            :filter="customFilter"
            :color="primaryColor"
            :disabled="isCategoryDisabled"
            append-icon="mdi-chevron-down"
            filled
            background-color="#f0eff7"
            item-text="categoryDescription"
            item-value="category"
            label="Biller Type"
            class="pt-0 pl-2"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 sm7 md7 lg7 xl7 data-qa="billerselection-flex-y1gi8">
          <v-autocomplete
            data-qa="companyId"
            v-model="biller.companyId"
            @change="selectCompanyId(biller.companyId, biller.category);confirmSelection()"
            @focus="loadImages"
            :items="values"
            :filter="customFilter"
            :color="primaryColor"
            :disabled="isCompanyIdDisabled"
            append-icon="mdi-chevron-down"
            filled
            background-color="#f0eff7"
            item-text="companyDescription"
            item-value="companyId"
            label="Biller"
            class="pt-0 pl-2"
          >
    <template v-slot:item="{ item }">
      <v-list-item-content data-qa="billerselection-list-item-content-ucquta">
        <v-row data-qa="billerselection-row-uxh3d">
              <img
                :src="getBillerIcons(item.companyDescription)"
                @error="onImageLoadFailure($event)"
                :width="getBillerIcons(item.companyDescription) ? '50' : '0'"
                :height="getBillerIcons(item.companyDescription) ? '30' : '0'"
               data-qa="billerselection-img-lpfsw"><v-flex :class="getBillerIcons(item.companyDescription) ? 'pt-1' : 'pl-12'" data-qa="billerselection-flex-7dnygv">{{ item.companyDescription }}</v-flex>
        </v-row>
      </v-list-item-content>
   </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm7 md7 lg7 xl7 data-qa="billerselection-flex-3jpkeh">
          <v-autocomplete
            data-qa="billerSubCategory"
            v-model="subCategory"
            @change="biller.subCategory = subCategory; updateSchema();confirmSelection()"
            :items="companyFilterBiller"
            :filter="customFilter"
            :color="primaryColor"
            :disabled="isSubCategoryDisabled"
            append-icon="mdi-chevron-down"
            filled
            background-color="#f0eff7"
            item-text="subCategoryDescription"
            item-value="subCategory"
            label="Plan"
            class="pt-0 pl-2"
          ></v-autocomplete>
        </v-flex>
      </v-row>
    </v-card-text>
    </v-form>

    <v-row class="pl-3 pb-2" data-qa="billerselection-row-y6akge">
            <v-flex class="pl-4 pr-3 py-2" data-qa="billerselection-flex-9ioaic">
              <v-btn
                class="increment font-weight-regular text-none white--text py-2 px-4"
                data-qa="loadBillerTemplate"
                @click="loadBillerTemplate()"
                :color="primaryColor"
                style="margin-left: 6px;"
                :disabled="
                  !biller.serviceProvided ||
                  !biller.category ||
                  !biller.companyId ||
                  (companyFilterBiller.length>0 && !biller.subCategory)
                  "
              >{{ $t("billPayments.next") }}</v-btn
              >
            </v-flex>
      </v-row>
              </v-card>
            </v-flex>
            <v-flex sm12 xs12 md3 lg3 xl3
              class="hidden-sm-and-down pl-3"
             data-qa="billerselection-flex-s9tdls">
              <bill-payments-history-btn
                :text="$t('billPayments.billPaymentHistory')"
                @click="navigateToHistory"
              />
            </v-flex>
          </v-layout>
    </v-flex>

    <v-spacer data-qa="billerselection-spacer-dpxq4j"></v-spacer>
  </div>
</template>

<script>
import CommonService from '@/service/commonService.js'
import '@/styles/pages/billPayments.scss'
import store from '@/core/store'
import event from '@/util/event'
import Button from '@/views/common/buttons/WrappedButton.vue'

export default {
  name: 'biller-selection',
  components: {
    'bill-payments-history-btn': Button
  },
  props: {},
  data () {
    return {
      isSubCategoryDisabled: true,
      isCompanyIdDisabled: true,
      isCategoryDisabled: true,
      serviceProvided: '',
      subCategory: '',
      category: '',
      billers: [],
      serviceFilterBiller: [],
      categoryFilterBiller: [],
      companyFilterBiller: [],
      biller: {},
      serviceProviders: [],
      values: [],
      classificationType: 'SERVICE-PROVIDED'
    }
  },
  methods: {
    async getGenericCodes () {
      const code = {
        codeReferences: [{ reference: 'BILLSERVICEPROVIDED' }]
      }
      // fetch Bill Service Provider - API call
      const response = await CommonService.getGenericCodes(code)
      if (response && response.aggregateCodes && response.aggregateCodes[0]) {
        if (response.aggregateCodes[0].codes) {
          this.serviceProviders = response.aggregateCodes[0].codes
        }
      }
    },
    updateSchema () {
      event.$emit('updateSchema', true)
    },
    async selectServiceProvided (service) {
      this.isCategoryDisabled = false
      this.biller.category = ''
      this.biller.companyId = ''
      this.biller.subCategory = ''
      this.subCategory = ''
      var customerId = JSON.parse(sessionStorage.getItem('username'))
      // Retrieve Billing Details
      if (customerId && service) {
        const response = await CommonService.getBillersforCustomer(customerId, this.classificationType, service)
        if (response && response.items) {
          this.billers = response.items
        } else {
          this.isCategoryDisabled = true
          store.dispatch('appStore/setAppData', {
            message: {
              title: 'Error',
              width: 400,
              persistent: true,
              saveButton: this.$t('common.okay'),
              saveCallback: this.resetScreen,
              content: 'No biller is registered for the user',
              type: 'error',
              component: 'dob-modal'
            }
          })
        }
      }
      this.serviceFilterBiller = this.billers.filter(
        (item) => item.serviceProvided === service
      )
      this.updateSchema()
    },
    selectCategory (category) {
      this.categoryFilterBiller = []
      this.isCompanyIdDisabled = false
      this.biller.companyId = ''
      this.biller.subCategory = ''
      this.subCategory = ''
      this.categoryFilterBiller = this.serviceFilterBiller.filter(
        (item) => item.category === category
      )
      this.updateSchema()
    },
    selectCompanyId (companyId, category) {
      this.companyFilterBiller = []
      this.isSubCategoryDisabled = false
      this.subCategory = ''
      this.biller.subCategory = ''
      this.companyFilterBiller = this.categoryFilterBiller.filter(
        (item) => item.subCategory && category === item.category && companyId === item.companyDescription
      )
      this.updateSchema()
    },
    loadImages () {
      const values = []
      // return require('@/assets/SVG_icons/Tick.svg')
      this.categoryFilterBiller.forEach(key => {
        values.push({
          image: this.getSvgIconSrc('Tick'),
          companyId: key.companyId,
          companyDescription: key.companyDescription
        })
      })
      this.values = values
    },
    getBillerIcons (name) {
      try {
        return this.customThemeEnabled ? `${this.appBaseUrl}assets/custom/Billers/${name}.svg` : `/assets/Billers/${name}.svg`
        // return require(`@/assets/Billers/${name}.svg`)
      } catch (e) {
        return undefined
      }
    },
    onImageLoadFailure (event) {
      event.target.src = this.customThemeEnabled ? `${this.appBaseUrl}assets/custom/Billers/Empty.jpg` : '/assets/Billers/Empty.jpg'
    },
    loadBillerTemplate () {
      if (this.companyFilterBiller && this.companyFilterBiller.length > 0) {
        this.billerSelected = this.companyFilterBiller.filter(
          (item) => item.subCategory === this.biller.subCategory
        )
      } else if (this.categoryFilterBiller && this.categoryFilterBiller.length > 0) {
        this.billerSelected = this.categoryFilterBiller.filter(
          (item) => item.companyDescription === this.biller.companyId
        )
      }
      // SELECTED BILLER -> this.billerSelected
      store.dispatch('userStore/setUserData', {
        selectedBiller: this.billerSelected
      })
      if (this.billerSelected && this.billerSelected[0] && this.billerSelected[0].supportedCurrency) {
        store.dispatch('userStore/setUserData', {
          billerCurrency: this.billerSelected[0].supportedCurrency
        })
      }
      event.$emit('loadBillerTemplate')
    },
    navigateToHistory () {
      this.$router.push({ path: '/billPayment' })
    },
    confirmSelection () {
      event.$emit('billerCheck', true)
    },
    customFilter (item, queryText, itemText) {
      if (item.codeDescription) {
        const textOne = item.codeDescription.toLowerCase()
        const searchText = queryText.toLowerCase()
        return textOne.indexOf(searchText) > -1
      }
    }
  },
  created () {
    this.getGenericCodes()
  }
}
</script>
